(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcstore-edg-natale"] && !Shopify.designMode) return;
  try {
    
function initializeEdg(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('[data-edg-track]');
  const toggle=root.querySelector('[data-edg-toggle]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=reduced.matches,hovered=false,focused=false;
  function update(){toggle.textContent=paused?root.dataset.play:root.dataset.pause;toggle.setAttribute('aria-pressed',String(paused));}
  function advance(direction){
    const cards=Array.from(track.children);
    if(!cards.length)return;
    const current=cards.reduce((best,card,index)=>Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-track.scrollLeft)?index:best,0);
    const max=track.scrollWidth-track.clientWidth;
    let target=cards[Math.min(cards.length-1,Math.max(0,current+direction))].offsetLeft-cards[0].offsetLeft;
    if(direction>0&&track.scrollLeft>=max-5)target=0;
    if(direction<0&&track.scrollLeft<=5)target=max;
    track.scrollTo({left:target,behavior:reduced.matches?'instant':'smooth'});
  }
  toggle.addEventListener('click',()=>{paused=!paused;update();});
  root.querySelector('[data-edg-prev]').addEventListener('click',()=>advance(-1));
  root.querySelector('[data-edg-next]').addEventListener('click',()=>advance(1));
  root.addEventListener('mouseenter',()=>hovered=true);
  root.addEventListener('mouseleave',()=>hovered=false);
  root.addEventListener('focusin',()=>focused=true);
  root.addEventListener('focusout',()=>{focused=false;});
  track.addEventListener('pointerdown',()=>{paused=true;update();});
  reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;update();}});
  update();
  const timer=setInterval(()=>{
    if(!root.isConnected){clearInterval(timer);return;}
    if(!paused&&!hovered&&!focused&&!document.hidden){
      const rect=root.getBoundingClientRect();
      if(rect.top<window.innerHeight&&rect.bottom>0)advance(1);
    }
  },4500);
}
document.querySelectorAll('[data-mc-edg]').forEach(initializeEdg);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mc-edg]').forEach(initializeEdg));

  } catch(e) { console.error(e); }
})();
})();
